export const AUTH_USER_SUCCESS = "AUTH_USER_SUCCESS";
export const AUTH_USER_ERROR = "AUTH_USER_ERROR";
export const AUTH_USER_REQUEST = "AUTH_USER_REQUEST";

export const LOGOUT_USER = "LOGOUT_USER";
